import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";
import { getToken, setToken, clearToken, tokenLuput } from "./token";

/* Pengurusan token kini berada dalam lib/token.js supaya api.js boleh
   menggunakannya tanpa kebergantungan pusingan. Dieksport semula di sini
   supaya import yang sedia ada di seluruh aplikasi terus berfungsi. */
export { getToken, setToken, clearToken, tokenLuput };

axios.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t && (cfg.url || "").includes("/api/")) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export const teksRalat = (detail, fallback = "Berlaku ralat. Sila cuba semula.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [pengguna, setPengguna] = useState(null);
  const [memuat, setMemuat] = useState(true);

  const semak = useCallback(async () => {
    if (!getToken()) {
      setPengguna(false);
      setMemuat(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/auth/saya`);
      setPengguna(data);
    } catch (e) {
      clearToken();
      setPengguna(false);
    } finally {
      setMemuat(false);
    }
  }, []);

  useEffect(() => {
    semak();
  }, [semak]);

  const masuk = async (id_masuk, kata_laluan) => {
    const { data } = await axios.post(`${API}/auth/login`, { id_masuk, kata_laluan });
    setToken(data.token);
    const me = await axios.get(`${API}/auth/saya`);
    setPengguna(me.data);
    return me.data;
  };

  const keluar = () => {
    clearToken();
    setPengguna(false);
    window.location.href = "/login";
  };

  return (
    <Ctx.Provider value={{ pengguna, memuat, masuk, keluar, semak, adminKah: pengguna?.peranan === "admin" }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
